import { useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import appInfo from '../../../../package.json';

import { FEATURE_FLAGS } from '~common';
import { PaddingBox } from '~components/atoms';
import { GooglePlacesSearchForVenue } from '~components/molecules';
import { AsyncListWithSearchForVenue } from '~components/molecules/pinning/AsyncListWithSearchForVenue';
import {
  PINNING_STEP,
  usePinningStepContext,
} from '~providers/PinningStepProvider';
import { IFormCreationValues, INITIAL_VALUES } from '~providers/useForm';
import { checkEnabledFeatureFlag } from '~utils';

export const StartAndFindVenueStep: React.FC = () => {
  const { pinningStep } = usePinningStepContext();

  const { resetForm } = useFormikContext<IFormCreationValues>();

  const isEnableVenueCreationWithGooglePlaceAPI = checkEnabledFeatureFlag(
    FEATURE_FLAGS.GOOGLE_PLACE_API_IN_VENUE_CREATION,
  );

  useEffect(() => {
    // This effect is triggered
    // when the user clicks the back icon to navigate back to the home screen.
    // or drop the current pinning form
    if (pinningStep === PINNING_STEP.START) {
      resetForm({ values: INITIAL_VALUES });
    }
  }, [pinningStep, resetForm]);

  const listVenue = isEnableVenueCreationWithGooglePlaceAPI ? (
    <GooglePlacesSearchForVenue />
  ) : (
    <AsyncListWithSearchForVenue />
  );

  return (
    <>
      <Stack gap={2} px={2.5} py={2} overflow="hidden" height="100%">
        {pinningStep === PINNING_STEP.START && (
          <Box>
            <Typography
              fontWeight="600"
              variant="h5"
              display="inline"
              color="text.highlight"
            >
              Find your venue
            </Typography>
            <Typography
              fontWeight="600"
              variant="h5"
              display="inline"
              color="text.dark"
              sx={{ ml: 1 }}
            >
              to start assigning stations
            </Typography>
          </Box>
        )}

        {listVenue}

        <PaddingBox />
      </Stack>

      {pinningStep === PINNING_STEP.START && (
        <PaddingBox textAlign="center">
          <Typography color="text.placeholder" variant="body2">
            {`Version ${appInfo.version.replace('v', '')}`}
          </Typography>
        </PaddingBox>
      )}
    </>
  );
};
